/*
  StarLux — turns a stacked list of Etsy review cards inside a product description
  into a one-at-a-time carousel with arrows, dots and gentle auto-advance.

  Markup contract (lives in the product description):
    <div data-slx-reviews> <div class='slx-rv'>...</div> ... </div>

  With JS off (or on a theme without this file) the cards simply stack — still readable.
*/
(function () {
  var AUTO_MS = 7000;

  var style = document.createElement('style');
  style.textContent = [
    '[data-slx-reviews].slx-rv-ready{position:relative;display:block;overflow:hidden;}',
    '[data-slx-reviews].slx-rv-ready .slx-rv-track{display:flex;transition:transform .45s cubic-bezier(.4,0,.2,1);will-change:transform;align-items:stretch;}',
    '[data-slx-reviews].slx-rv-ready .slx-rv{flex:0 0 100%;width:100%;box-sizing:border-box;margin:0!important;}',
    '.slx-rv-bar{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:10px;}',
    '.slx-rv-dots{display:flex;gap:6px;flex-wrap:wrap;}',
    '.slx-rv-dot{width:6px;height:6px;border-radius:50%;background:currentColor;opacity:.22;border:0;padding:0;cursor:pointer;transition:opacity .2s ease,transform .2s ease;}',
    '.slx-rv-dot[aria-current="true"]{opacity:.75;transform:scale(1.35);}',
    '.slx-rv-nav{display:flex;gap:6px;align-items:center;}',
    '.slx-rv-btn{width:30px;height:30px;border-radius:50%;border:1px solid rgba(46,58,44,.2);background:transparent;color:inherit;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;padding:0;transition:background .2s ease,border-color .2s ease;}',
    '.slx-rv-btn:hover{background:rgba(46,58,44,.07);border-color:rgba(46,58,44,.4);}',
    '.slx-rv-btn svg{width:13px;height:13px;}',
    '.slx-rv-count{font-size:.75rem;opacity:.45;font-variant-numeric:tabular-nums;}',
    '@media (prefers-reduced-motion: reduce){[data-slx-reviews].slx-rv-ready .slx-rv-track{transition:none;}}'
  ].join('');
  document.head.appendChild(style);

  var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function build(box) {
    if (box.dataset.slxReady === '1') return;
    var cards = Array.prototype.slice.call(box.querySelectorAll('.slx-rv'));
    if (cards.length === 0) return;
    box.dataset.slxReady = '1';

    if (cards.length === 1) { box.classList.add('slx-rv-ready'); return; }

    var track = document.createElement('div');
    track.className = 'slx-rv-track';
    cards.forEach(function (c) { track.appendChild(c); });
    box.appendChild(track);
    box.classList.add('slx-rv-ready');
    box.setAttribute('aria-roledescription', 'carousel');
    box.setAttribute('aria-label', 'Customer reviews');

    var bar = document.createElement('div');
    bar.className = 'slx-rv-bar';

    var dots = document.createElement('div');
    dots.className = 'slx-rv-dots';

    var nav = document.createElement('div');
    nav.className = 'slx-rv-nav';

    var count = document.createElement('span');
    count.className = 'slx-rv-count';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'slx-rv-btn';
    prev.innerHTML = ARROW_L;
    prev.setAttribute('aria-label', 'Previous review');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'slx-rv-btn';
    next.innerHTML = ARROW_R;
    next.setAttribute('aria-label', 'Next review');

    nav.appendChild(count);
    nav.appendChild(prev);
    nav.appendChild(next);

    var i = 0;
    var timer = null;

    cards.forEach(function (c, idx) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'slx-rv-dot';
      d.setAttribute('aria-label', 'Review ' + (idx + 1));
      d.addEventListener('click', function () { go(idx, true); });
      dots.appendChild(d);
    });

    bar.appendChild(dots);
    bar.appendChild(nav);
    box.parentNode.insertBefore(bar, box.nextSibling);

    function render() {
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      var ds = dots.children;
      for (var k = 0; k < ds.length; k++) {
        ds[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
      cards.forEach(function (c, k) { c.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      count.textContent = (i + 1) + ' / ' + cards.length;
    }

    function go(n, stop) {
      i = (n + cards.length) % cards.length;
      render();
      if (stop) halt();
    }

    function start() {
      if (timer) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () { go(i + 1); }, AUTO_MS);
    }
    function halt() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    prev.addEventListener('click', function () { go(i - 1, true); });
    next.addEventListener('click', function () { go(i + 1, true); });
    box.addEventListener('mouseenter', halt);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', halt);

    render();
    start();
  }

  function scan() {
    var boxes = document.querySelectorAll('[data-slx-reviews]');
    for (var i = 0; i < boxes.length; i++) build(boxes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
